import { Button, Input } from "antd";
import { Form } from "antd";
import React from "react";
import { UserOutlined, MailOutlined } from "@ant-design/icons";
import { BsLock } from "react-icons/bs";

function LoginForm({ form, onFinish, info, setAction, setIsModalVisible }) {
  return (
    <div>
      <Form name="login" form={form} onFinish={onFinish}>
        <Form.Item
          name="email"
          rules={[
            {
              required: true,
              type: "email",
              message: info.t("insertEmail"),
            },
          ]}
        >
          <Input
            prefix={<MailOutlined />}
            placeholder={info.t("email")}
            onChange={() => {
              setAction("login");
            }}
          ></Input>
        </Form.Item>
        <Form.Item
          name="password"
          rules={[
            {
              required: true,
              message: info.t("insertPassword"),
            },
          ]}
          onChange={() => {
            setAction("login");
          }}
        >
          <Input.Password
            prefix={<BsLock />}
            placeholder={info.t("password")}
          />
        </Form.Item>
        {/* <Button className="login-btn" htmlType="submit">
    {info.t("login")}
  </Button> */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            gap: 10,
          }}
        >
          <Button
            type="primary"
            htmlType="submit"
            style={{
              // width: "100%",
              flexGrow: 1,
              marginLeft: -1,
              marginBottom: 10,
              backgroundColor: "#5382a4",
            }}
          >
            {info.t("login")}
          </Button>
          <Button
            type="default"
            htmlType="button"
            onClick={() => setIsModalVisible(false)}
            style={{ flexGrow: 1 }}
          >
            {info.t("cancel")}
          </Button>
        </div>
      </Form>
    </div>
  );
}

export default LoginForm;
